const affiliateRequest = apiBase ? (apiBase + "/affiliate-request") : null;

// Fix to pass form to this function too
const submitFormbyAPI = async (formData, submitButton, form) => {
  submitButton.disabled = true;
  submitButton.textContent = window.formErrors?.Submitting_txt || 'Submitting...';
  clearFormMessages();
  try {
    const response = await fetch(affiliateRequest, {
      method: 'POST',
      body: formData
    });

    if (!response.ok) {
    const res = await response.json();
      
    showFormErrorMessage(res.message);
      
      return null;
    }

    const res = await response.json();
    console.log('API Success:', res);
    form.reset();
    // showFormSuccessMessage(res.message);
    document.getElementById('gb_affiliation_program_text_section').classList.add('hidden')
    document.getElementById('gb_affiliation_program_form_section').classList.add('hidden')
    document.getElementById('gb_affiliation_program_success_section').classList.remove('hidden')
    // scroll to top of success section
    document.getElementById('gb_affiliation_program_success_section').scrollIntoView({ behavior: "smooth", block: "start" });

  } catch (error) {
    console.error('API Error:', error);
    showFormErrorMessage(window.formErrors?.submit_error_1 || 'There was a problem submitting the form. Please try again.');

  } finally {
    submitButton.disabled = false;
    submitButton.textContent = window.formErrors?.submit_request || 'Submit Request';
  }
}
// function showFormSuccessMessage(message) {
//   const successEl = document.querySelector('.form__message .form-status.form-status-list');
//   const errorEl = document.querySelector('.form__message .caption-large.text-body');
//   if (successEl) successEl.textContent = message;
//   if (errorEl) errorEl.textContent = '';
//   setTimeout(() => {
//   if (successEl) successEl.textContent = '';    
//   }, 5000);
// }

function showFormErrorMessage(message) {
  const successEl = document.querySelector('.form__message .form-status.form-status-list');
  const errorEl = document.querySelector('.form__message .caption-large.text-body');
  if (errorEl) errorEl.textContent = message;
  if (successEl) successEl.textContent = '';
}

function clearFormMessages() {
  const successEl = document.querySelector('.form__message .form-status.form-status-list');
  const errorEl = document.querySelector('.form__message .caption-large.text-body');
  if (successEl) successEl.textContent = '';
  if (errorEl) errorEl.textContent = '';
}

document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('ContactForm_affiliate');
  if (!form) return;

  // Utility
  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function showError(input, message) {
    clearError(input);
    const error = document.createElement('div');
    error.className = 'field_error';
    error.textContent = message;
    input.parentNode.appendChild(error);
  }

  function clearError(input) {
    const existing = input.parentNode.querySelector('.field_error');
    if (existing) existing.remove();
  }

  function clearAllErrors() {
    form.querySelectorAll('.field_error').forEach(el => el.remove());
  }

  // Use correct IDs from your form
  const name = document.getElementById('ContactForm_affiliate-full-name');
  const email = document.getElementById('ContactForm_affiliate-email');
  const company = document.getElementById('ContactForm_affiliate-company');
  const message = document.getElementById('ContactForm_affiliate-description');

  // Add real-time error clearing on input
  [name, email, company, message].forEach(field => {
    field.addEventListener('input', () => clearError(field));
  });
  
  // Name validation
  name.addEventListener('input', function () {
    this.value = this.value
      .replace(/[^a-zA-ZÀ-ÿ' -]/g, '') // only valid name chars
      .replace(/\s{2,}/g, ' ')
      .trimStart();

    if (name.value.length > 64) {
    showError(name, window.formErrors.full_name_mex);
    }
  });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    clearAllErrors();

    let hasErrors = false;

    if (!name.value.trim()) {
      showError(name, window.formErrors.full_name);
      hasErrors = true;
    }
    if (name.value.length > 64) {
    showError(name, window.formErrors.full_name_mex);
    hasErrors = true;
    }
    if (!email.value.trim()) {
      showError(email, window.formErrors.email_1);
      hasErrors = true;
    } else if (!isValidEmail(email.value.trim())) {
      showError(email, window.formErrors.email_2);
      hasErrors = true;
    }
    if (!message.value.trim()) {
      showError(message, window.formErrors.description);
      hasErrors = true;
    }

    if (hasErrors) {
      e.preventDefault();
      return;
    }

    const formData = new FormData();
    formData.append('customerId', window.customerData ? window.customerData.customerId : '');
    formData.append('type', 'affiliate');
    formData.append('companyName', company.value.trim());
    formData.append('email', email.value.trim());
    formData.append('name', name.value.trim());
    formData.append('message', message.value.trim())   

    const submitButton = form.querySelector('button[type="submit"]');
    // called
    submitFormbyAPI(formData, submitButton, form);
  });
});